var exports = {
  "uW": "SettingsSection.module__section___MGR3Mk",
  "bV": "SettingsSection.module__sectionHeader___MGR3Mk",
  "Uj": "SettingsSection.module__sectionHeaderWithActions___MGR3Mk",
  "Yc": "SettingsSection.module__sectionHeaderText___MGR3Mk",
  "sq": "SettingsSection.module__sectionTitleRow___MGR3Mk",
  "vO": "SettingsSection.module__sectionActions___MGR3Mk",
  "N1": "SettingsSection.module__subsectionActions___MGR3Mk",
  "Gf": "SettingsSection.module__sectionTitle___MGR3Mk",
  "yV": "SettingsSection.module__sectionDescription___MGR3Mk",
  "f5": "SettingsSection.module__sectionContent___MGR3Mk",
  "t8": "SettingsSection.module__subsectionHeader___MGR3Mk",
  "Wf": "SettingsSection.module__subsectionTitle___MGR3Mk",
  "Yq": "SettingsSection.module__subsectionDescription___MGR3Mk",
  "No": "SettingsSection.module__subsectionContent___MGR3Mk",
};

module.exports = exports;
